import React from "react"
import "../styles/styles.scss"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Demo = () => {
    const data = useStaticQuery(graphql`
    query {
      heroimage: file(relativePath: { eq: "vehicle.png" }) {
        childImageSharp {
          fluid(maxWidth: 1540) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
    `)
    return(
        <div className="demo">
        <div className="container">
        <div className="row">
        <div className="column">
        <div className="maintext"> Ready to get started?</div>
        <div className="row">
        <div className="subtext"> Would you like to learn more or request a demo of the software? Get in touch 
        and together we will analyze what our software can do for your processes.   </div>
        </div>
        <div className = "row">
        <a href="mailto:contact@skialabs.com"> <button className="buttondemo">Get in touch.</button> </a> 
        </div>
        </div>
        <div className="column">
        <Img className = 'sideimage' fluid={data.heroimage.childImageSharp.fluid} />
        </div>
        </div>
        </div>
        </div>
    )
}

export default Demo